/**
 * RISKS.ROUTE
 * Main risks view - displays the document unique
 */
import NavRisks from "../ui/nav-risks"
import { RISKS_TABS } from "../utils/risks-tabs.config"
import RisksValidated from "@/features/risks/entities/risk/ui/RisksValidated"
import { useEffect } from "react"
import riskStore from "@/features/risks/entities/risk/model/risk.store"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import UnitFilters from "@/features/risks/entities/unit/ui/UnitFilters"
import unitStore from "@/features/risks/entities/unit/model/unit.store"
import RisksValidatedHeader from "../entities/risk/ui/RisksValidatedHeader"
import { isToday } from "@/utils/format-date.utils"
import { RisksProvider } from "../entities/risk/context/RisksContext"
import { useLocation } from "react-router-dom"

export default function RisksRoute() {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const selectedDate = useAppSelector(riskStore.selectors.selectedDate)
  const locationState = (location.state as any) ?? {}
  const keepSort: boolean = locationState.keepSort === true

  useEffect(() => {
    dispatch(riskStore.actions.search({ value: null, columns: ["name"] }))
    dispatch(riskStore.actions.setFilter(locationState.filter ?? {}))
    dispatch(riskStore.actions.setSelectedDate(new Date()))
    dispatch(unitStore.actions.clearSelected())
    dispatch(riskStore.actions.setActive(null))
    dispatch(unitStore.actions.setActive(null))
    dispatch(
      keepSort
        ? riskStore.actions.sort({ key: "dateValidated", asc: false })
        : riskStore.actions.sort({ key: "size", asc: false, keySecondary: "riskMax.valueEffective", ascSecondary: false })
    )
    dispatch(unitStore.thunks.fetchAndSet())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  useEffect(() => {
    dispatch(riskStore.thunks.fetchValidatedAndSet(isToday(selectedDate) ? null : selectedDate))
  }, [selectedDate, dispatch])

  return (
    <RisksProvider>
      <NavRisks tabs={RISKS_TABS}>
        <RisksValidatedHeader />
        <div className="risks-document">
          <UnitFilters />
          <RisksValidated />
        </div>
      </NavRisks>
    </RisksProvider>
  )
}
